import React from 'react';
import { TrendingUp, TrendingDown, AlertCircle } from 'lucide-react';
import BentoWidgetCard, { WidgetQuestion } from '../BentoWidgetCard';
import { getPartnerPerformanceData } from '../../../../utils/aiBriefingsData';
interface PartnerPerformanceWidgetProps {
  onHide?: () => void;
  onAsk?: (question: string) => void;
}
const PartnerPerformanceWidget: React.FC<PartnerPerformanceWidgetProps> = ({
  onHide,
  onAsk
}) => {
  const data = getPartnerPerformanceData();
  const questions: WidgetQuestion[] = [{
    id: '1',
    text: 'Quali partner supportare?'
  }, {
    id: '2',
    text: 'Azioni prioritarie?'
  }];
  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'Alta':
        return 'text-red-600 bg-red-50';
      case 'Media':
        return 'text-yellow-600 bg-yellow-50';
      default:
        return 'text-blue-600 bg-blue-50';
    }
  };
  return <BentoWidgetCard id="partner-performance" title="Partner Performance & Azioni" size="M" lastUpdated="12 min fa" questions={questions} onHide={onHide} onAsk={onAsk} data-id="element-1496">
      <div className="space-y-2 mb-4" data-id="element-1497">
        <p className="text-xs font-semibold text-gray-900" data-id="element-1498">Ranking Partner</p>
        {data.rankings.map((partner, index) => <div key={index} className="flex items-center justify-between bg-gray-50 rounded p-2" data-id="element-1499">
            <div className="flex items-center gap-2 flex-1" data-id="element-1500">
              <span className="text-xs font-bold text-gray-500" data-id="element-1501">
                #{index + 1}
              </span>
              <span className="text-xs font-medium text-gray-900" data-id="element-1502">
                {partner.name}
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-1503">
              <span className="text-sm font-bold text-gray-900" data-id="element-1504">
                {partner.score}
              </span>
              <div className="flex items-center gap-0.5" data-id="element-1505">
                {partner.trend > 0 ? <TrendingUp className="h-3 w-3 text-green-600" data-id="element-1506" /> : <TrendingDown className="h-3 w-3 text-red-600" data-id="element-1507" />}
                <span className={`text-xs font-medium ${partner.trend > 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-1508">
                  {Math.abs(partner.trend)}
                </span>
              </div>
            </div>
          </div>)}
      </div>

      <div data-id="element-1509">
        <p className="text-xs font-semibold text-gray-900 mb-2" data-id="element-1510">
          Azioni Consigliate
        </p>
        {data.actions.map((action, index) => <div key={index} className="flex items-start gap-2 bg-gray-50 rounded p-2 mb-2" data-id="element-1511">
            <AlertCircle className="h-4 w-4 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-1512" />
            <div className="flex-1" data-id="element-1513">
              <p className="text-xs font-medium text-gray-900" data-id="element-1514">
                {action.partner}
              </p>
              <p className="text-xs text-gray-700" data-id="element-1515">{action.action}</p>
            </div>
            <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${getPriorityColor(action.priority)}`} data-id="element-1516">
              {action.priority}
            </span>
          </div>)}
      </div>
    </BentoWidgetCard>;
};
export default PartnerPerformanceWidget;